module.exports = __webpack_public_path__ + "static/media/won.bbb2b48a.gif";